import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Card, Row, Col, Input, Alert } from "antd";
import millify from 'millify';
import Loader from './Loader';
import { useGetCryptosQuery } from '../services/cryptoApi';


const Cryptocurrencies = ({ simplified }) => {
  const count = simplified ? 10 : 100;
  const { data: cryptosList, isFetching, isError, error } = useGetCryptosQuery(count);
  const [cryptos, setCryptos] = useState(cryptosList?.data?.coins);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const filteredData = cryptosList?.data?.coins.filter((coin) => coin.name.toLowerCase().includes(searchTerm.toLowerCase()));
    setCryptos(filteredData);
  }, [cryptosList, searchTerm]);

  if (isFetching) return <Loader />;

  if (isError) {
    return (
      <Alert
        message="Unable to Load Cryptocurrency Data"
        description={error?.status === 429 ? "Rate limit exceeded. Please wait a moment and refresh the page." : "Failed to fetch cryptocurrency data. Please try again later."}
        type="warning"
        showIcon
        style={{ margin: '20px' }}
      />
    );
  }

  return (
    <>
      {!simplified && (
        <div className="search-crypto">
          <Input placeholder="Search Cryptocurrency" onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
      )}
      <Row gutter={[32, 32]} className="crypto-card-container">
        {cryptos?.map((currency) => (
          <Col xs={24} sm={12} lg={6} className="crypto-card" key={currency.uuid}>
            <Link to={`/crypto/${currency.uuid}`}>
              <Card
                title={`${currency.rank}. ${currency.name}`}
                extra={<img className="crypto-image" src={currency.iconUrl} alt="" />}
                hoverable
              >
                <p>Price: ${currency.price ? millify(currency.price) : 'N/A'}</p>
                <p>Market Cap: ${currency.marketCap ? millify(currency.marketCap) : 'N/A'}</p>
                <p>Daily Change: {currency.change ? `${millify(currency.change)}%` : 'N/A'}</p>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Cryptocurrencies;
